module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/receive.839d16d5.jpg";